export const generalKey = 'product_sp_400w_solar_panel';
export const whiteLocaleList = ['us']; //白名单
export const productPageUrl = 'stream-2-product-page';
export const tabsValues = ['Product', 'Bundles'];
export const productPageTheme = 'white'; //主题色
